import RatingFirstIcon from "@/assets/images/rating_star_1.svg?react";
import RatingSecondIcon from "@/assets/images/rating_star_2.svg?react";
import RatingThirdIcon from "@/assets/images/rating_star_3.svg?react";
import RatingFourthIcon from "@/assets/images/rating_star_4.svg?react";
import RatingFifthIcon from "@/assets/images/rating_star_5.svg?react";
import RatingEmptyIcon from "@/assets/images/rating_star_empty.svg?react";
import {type FC} from "react";

const StarSvgComponent: FC<{
  index: number;
  currentValue: number;
  className?: string;
}> = ({currentValue, className, index}) => {
  if (index === 0 && index < currentValue) return <RatingFirstIcon className={`size-5 shrink-0 ${className}`} />;
  if (index === 1 && index < currentValue) return <RatingSecondIcon className={`size-5 shrink-0 ${className}`} />;
  if (index === 2 && index < currentValue) return <RatingThirdIcon className={`size-5 shrink-0 ${className}`} />;
  if (index === 3 && index < currentValue) return <RatingFourthIcon className={`size-5 shrink-0 ${className}`} />;
  if (index === 4 && index < currentValue) return <RatingFifthIcon className={`size-5 shrink-0 ${className}`} />;

  return <RatingEmptyIcon className={`size-5 shrink-0 ${className}`} />;
};

export default StarSvgComponent;
